export default {
  play: 'Jouer maintenant',
  fullscreen: 'Mode plein écran',
  addToFavorites: 'Ajouter aux favoris',
  removeFromFavorites: 'Retirer des favoris',
  similarGames: 'Jeux similaires',
  howToPlay: 'Comment jouer',
  gameDescription: 'Description du jeu',
  controlsAndInstructions: 'Contrôles et instructions',
  share: 'Partager',
  gameUnavailable: 'Jeu indisponible',
  tryAgainLater: 'Ce jeu est actuellement indisponible. Veuillez réessayer plus tard.',
  openInNewTab: 'Ouvrir dans un nouvel onglet',
  gameTitle: 'Titre du jeu',
  genres: 'Genres de jeu',
  tags: 'Tags',
  noGenre: 'Aucun genre',
  noTags: 'Aucun tag',
  new: 'Nouveau jeu',
  playAmazingGame: 'Jouez à ce jeu incroyable maintenant !',
  noSimilarGames: 'Aucun jeu similaire',
  gameNotFound: 'Jeu non trouvé',
  gameNotExistOrRemoved: 'Le jeu que vous recherchez n\'existe pas ou a été supprimé.',
  backToHome: 'Retour à l\'accueil',
  seoTitle: '{title} - Jouer en ligne - GoGameVault',
  seoTitleNotFound: 'Jeu non trouvé - GoGameVault',
  seoKeywords: 'jouer {title}, jeux en ligne gratuits, jeux {tags}',
  gameFeatures: 'Caractéristiques du jeu',
  controlDetails: 'Détails des contrôles'
}; 